import TabPage from "./../factories/tab-page";
import "./../bindings/bao-searcher";
import BaseViewModel from "./../factories/base-view-model2";
import BaoDialog from "./../factories/bao-dialog";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
class TeamCalendar extends BaseViewModel {
    ShiftbookTab: TabPage;
    Name: KnockoutObservable<string> = ko.observable();
    HolidaySchemaId: KnockoutObservable<string> = ko.observable();
    TeamCalendarId: KnockoutObservable<string> = ko.observable();
    HolidaySchemaName: KnockoutObservable<string> = ko.observable();
    Color: string = "text-success";
    Icon: string = "fal fa-calendar";
    Sort: number = 39;
    IsFavorite: KnockoutObservable<boolean> = ko.observable(false);
    HolidaySchemaSearcher: Bindings.baoSearcher = {
        SearchType: "HolidaySchema",
        ObjectId: this.HolidaySchemaId,
        ObjectValue: "Name",
        AutoComplete: true,
        AutoSearch: true
    };
    constructor(tabPage: TabPage) {
        super(tabPage);
    }
    InitUrl() {
        return "TeamCalendar/Init";
    }
    init() {
        Bao.bindEvent('FavoriteIcon:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        Bao.bindEvent('TeamCalendarFavorite:refresh', (value) => {
            this.IsFavorite(!this.IsFavorite());
        });
        return $.when(super.init(), super.InitTabController()).then(() => {
            this.isQuickStartModuleActive();
            this.loadTabs()
        });
    }
    CompleteCheck() {
        var isComplete = true;
        if (Bao.Utils.String.IsNullOrEmpty(this.Name()) || Bao.Utils.String.IsNullOrEmpty(this.HolidaySchemaId())) {
            isComplete = false;
        }
        if (!isComplete) {
            new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    }
    changeFavoriteStatus = () => {
        var promise;
        if (this.IsFavorite()) {
            promise = this.removeQuickStartModuleWebUrl();
        }
        else {
            promise = this.addQuickStartModule();
        }
        promise.then(() => { Bao.raiseEvent('QuickStartModules:refresh', null); });
    };
    addQuickStartModule = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/AddQuickStartModule", JSON.stringify({
            caption1: this.Name(),
            caption2: this.Name(),
            caption3: this.Name(),
            caption4: this.Name(),
            caption5: this.Name(),
            webUrl: this.GetHolidaySchemaDeepLink(),
            color: this.Color,
            icon: this.Icon,
            sort: this.Sort
        })).done(result => {
            if (result) {
                Bao.raiseEvent('TeamCalendarFavorite:refresh', {});
            }
            this.TabPage.IsLoading(false);
        });
    };
    removeQuickStartModuleWebUrl = () => {
        this.TabPage.IsLoading(true);
        return Bao.post("StartModule/RemoveQuickStartModuleByWebUrl", JSON.stringify({
            webUrl: this.GetHolidaySchemaDeepLink()
        })).done(result => {
            if (result) {
                Bao.raiseEvent('TeamCalendarFavorite:refresh', {});
            }
            this.TabPage.IsLoading(false);
        });
    };

    isQuickStartModuleActive = () => {
        return Bao.post("StartModule/IsQuickStartModuleActive", JSON.stringify({
            webUrl: this.GetHolidaySchemaDeepLink()
        })).done(result => {
            this.IsFavorite(result);
        });
    }

    GetHolidaySchemaDeepLink() {
        return "#/teamcalendarview/" + this.TeamCalendarId();
    }
    private loadTabs = () => {
        this.ShiftbookTab = new TabPage();
        this.ShiftbookTab.IsClosable(false);
        this.ShiftbookTab.Url("TeamCalendarShiftbook");
        this.ShiftbookTab.AutoSelect = true;
        this.TabController.AddTab(this.ShiftbookTab);
    };
}
export default TeamCalendar;